// src/components/Screen4_RankTestDrive.jsx
import React, { useState, useEffect } from 'react';
import { useAppContext } from '../context/AppContext';
import { fetchCarList } from '../api';
import RankCarRow from './RankCarRow';

function Screen4_RankTestDrive() {
    const { rankingsTestDrive, updateRankings, showScreen } = useAppContext();
    const [cars, setCars] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const loadCars = async () => {
            setIsLoading(true);
            const carList = await fetchCarList('MPV');
            setCars(carList);
            setIsLoading(false);
        };
        loadCars();
    }, []);

    const handleRankClick = (carId) => {
        updateRankings('testDrive', carId);
    };

    // Check completion status
    const rankedCount = rankingsTestDrive.length;
    const isComplete = rankedCount >= 3;

    return (
        <div id="screen-4-testdrive" className="screen screen_padding">
            <h2 className="title_style text-2xl font-semibold text-center mb-2">Which car would you like to register for Test drive?</h2>
            <p className="text-sm text-center mb-6 ">(Rank minimum 3)</p>

            <div id="rank-list-container-testdrive" className="space-y-3 mb-6">
                {isLoading && (
                    <div id="rank-list-loading-testdrive" className="text-center">
                        <i className="fas fa-spinner fa-spin text-2xl"></i>
                        <p>Loading cars...</p>
                    </div>
                )}
                {!isLoading && cars.map(car => {
                    const rank = rankingsTestDrive.indexOf(car.id) + 1;
                    return (
                        <RankCarRow 
                            key={car.id} 
                            car={car} 
                            rank={rank > 0 ? rank : null}
                            onClick={handleRankClick}
                        />
                    );
                })}
            </div>

            <button 
                id="complete-ranking-btn-testdrive" 
                disabled={!isComplete}
                onClick={() => showScreen('screen-5-design')}
                className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-lg font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 disabled:bg-gray-400"
            >
                Next
            </button>
            {!isComplete && (
                <p id="complete-ranking-info-testdrive" className="text-center text-sm mt-2">
                    Please rank at least 3 cars to continue. ({rankedCount}/3 minimum)
                </p>
            )}
        </div>
    );
}

export default Screen4_RankTestDrive;